import { Card } from '@/components/ui/card';
import { Users, Store, CreditCard, AlertCircle } from 'lucide-react';

interface KPICardsProps {
  customers?: number;
  suppliers?: number;
  accounts?: number;
  missingBills?: number;
}

export function KPICards({ 
  customers = 0, 
  suppliers = 0, 
  accounts = 0, 
  missingBills = 0 
}: KPICardsProps) {
  const kpis = [
    {
      icon: Users,
      label: 'Customers',
      value: customers,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600'
    },
    {
      icon: Store,
      label: 'Suppliers',
      value: suppliers,
      color: 'from-indigo-500 to-indigo-600',
      bgColor: 'bg-indigo-50',
      iconColor: 'text-indigo-600'
    },
    {
      icon: CreditCard,
      label: 'Accounts',
      value: accounts,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600'
    },
    {
      icon: AlertCircle,
      label: 'Missing Bills',
      value: missingBills,
      color: 'from-amber-500 to-amber-600',
      bgColor: 'bg-amber-50',
      iconColor: 'text-amber-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {kpis.map(({ icon: Icon, label, value, color, bgColor, iconColor }) => (
        <Card key={label} className="shadow-lg border-0 overflow-hidden">
          <div className={`h-1 bg-gradient-to-r ${color}`} />
          <div className="p-6">
            <div className="flex items-center justify-between mb-3">
              <div className={`p-3 rounded-lg ${bgColor}`}>
                <Icon className={`h-5 w-5 ${iconColor}`} />
              </div>
              <div className="text-3xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent">
                {value.toLocaleString()}
              </div>
            </div>
            <div className="text-sm font-medium text-slate-600">{label}</div>
          </div>
        </Card>
      ))}
    </div>
  );
}
